import apiConfig from "../../../config/api";
import movConfig from "../config/configuration"

const getToken = () => localStorage.getItem("AccessToken");
export const defaultHeaders = () => ({
  "Content-Type": "application/json",
  "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
  Authorization: `Bearer ${getToken()}`,
});


export const crearPlanMovilidadAPI = (idempresa, nombreEmpresa, idcentro, nombreCentro, Rutusuario, nombre, apellido, Correo) =>
  fetch(`${movConfig.apiUriMovilidad}/crearPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idempresaNavigation: {
        idempresa,
        nombre: nombreEmpresa,
      },
      idcentroNavigation: {
        idcentro,
        nombre: nombreCentro,
      },
      rutusuarioNavigation: {
        Rutusuario,
        Nombre: `${nombre} ${apellido}`,
        Correo,
      },
    }),
  });

export const editarPlanMovilidadAPI = (idplanMovilidad, estadoPlan = null, estadoEjecucion = null, estadoProceso = null, habilitarTokenEncuesta = null, cantidadHombresCentro = null, cantidadMujeresCentro = null, fechaCierreEncuestaTrabajador = null, Rutusuario = null, nombre = null, apellido = '', Correo = null) =>
  fetch(`${movConfig.apiUriMovilidad}/editarPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idplanMovilidad,
      // parámetros opcionales, los manejo desde acciones
      estadoPlan,
      estadoEjecucion,
      estadoProceso,
      habilitarTokenEncuesta,
      cantidadHombresCentro,
      cantidadMujeresCentro,
      fechaCierreEncuestaTrabajador,
      // se requieren a cambiar de encargado
      rutusuarioNavigation: (Rutusuario != null) ? ({
        Rutusuario,
        Nombre: `${nombre} ${apellido}`,
        Correo,
      }) : null,
    }),
  });

export const getEstadisticasPlanMovilidadAPI = (idempresa, idcentro, rutusuario) =>
  fetch(`${movConfig.apiUriMovilidad}/getEstadisticasPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idempresa,
      idcentro,
      rutusuario,
    }),
  });

export const getListadoPlanesMovilidadAPI = (idempresa, idcentro, rutusuario=null) =>
  fetch(`${movConfig.apiUriMovilidad}/getListadoPlanesMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idempresa,
      idcentro,
      rutusuario,
    }),
  });

export const getListadoMedidasPorPlanMovilidadAPI = (idPlanMovilidad) =>
  fetch(`${movConfig.apiUriMovilidad}/getListadoMedidasPorPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify(idPlanMovilidad),
  });

export const getListadoSubMedidasPorPlanMovilidadAPI = (idPlanMovilidad) =>
  fetch(`${movConfig.apiUriMovilidad}/getListadoSubMedidasPorPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify(idPlanMovilidad),
  });

export const getListadoSubMedidasPorMedidaAPI = (idPlanMovilidadMedida) =>
  fetch(`${movConfig.apiUriMovilidad}/getListadoSubMedidasPorMedida`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify(idPlanMovilidadMedida),
  });

export const getListadoTareasPorSubMedidaAPI = (idPlanMovilidadSubMedida) =>
  fetch(`${movConfig.apiUriMovilidad}/getListadoTareasPorSubMedida`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify(idPlanMovilidadSubMedida),
  });

// no la uso, pq la edito en el anterior
export const editarPlanMovilidadEncuestaAPI = (idPlanMovilidad, cantidadHombresCentro, cantidadMujeresCentro, fechaCierreEncuestaTrabajador) =>
  fetch(`${movConfig.apiUriMovilidad}/editarPlanMovilidadEncuesta`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idPlanMovilidad,
      cantidadHombresCentro,
      cantidadMujeresCentro,
      fechaCierreEncuestaTrabajador,
    }),
  });

export const escogerTiposUsuariosRiesgosPlanMovilidadAPI = (idPlanMovilidad) =>
  fetch(`${movConfig.apiUriMovilidad}/EscogerTiposUsuariosRiesgosPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idPlanMovilidad,
    }),
  });

export const calcularMedidasSubmedidasTareasPlanMovilidadAPI = (idPlanMovilidad) =>
  fetch(`${movConfig.apiUriMovilidad}/CalcularMedidasSubmedidasTareasPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idPlanMovilidad,
    }),
  });

export const obtenerDocumentoCombinacionPlanMovilidadAPI = (idPlanMovilidad) =>
  fetch(`${movConfig.apiUriMovilidad}/obtenerDocumentoCombinacionPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idPlanMovilidad,
    }),
  });

// diseñado para etapa de borrador.
export const editarSubMedidaPlanMovilidadAPI = (idplanSubMedida, subMedidaElegida, fechaInicio, fechaLimite) =>
  fetch(`${movConfig.apiUriMovilidad}/editarSubMedidaPlanMovilidad`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idplanSubMedida,
      subMedidaElegida,
      fechaInicio,
      fechaLimite,
    }),
  });

// para el botón guardar de etapa de seguimiento
export const editarSubMedidaTareaSeguimientoAPI = (idplanSubMedida, totalEntrega, estadoSubMedida = 0, totalObjetivo = null, tblPlanSubMedidaTarea = [], fechaInicio = null, fechaLimite = null) =>
  fetch(`${movConfig.apiUriMovilidad}/editarSubMedidaTareaSeguimiento`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idplanSubMedida,
      estadoSubMedida,
      totalEntrega,
      totalObjetivo,
      tblPlanSubMedidaTarea,
      fechaInicio,
      fechaLimite,
    }),
  });

export const getListadoContenidosCompletoAPI = () =>
  fetch(`${movConfig.apiUriContenidos}/getListadoContenidosCompleto`, {
    method: "POST",
    headers: defaultHeaders(),
  });

export const getListadoContenidosPorSeccionEtapaAPI = (tipoSeccion, tipoEtapa) =>
  fetch(`${movConfig.apiUriContenidos}/getListadoContenidosPorSeccionEtapa`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      tipoSeccion,
      tipoEtapa,
    }),
  });


export const getAccidentesListAPI = (rutEmpresa, idCentro) =>
  fetch(`${movConfig.apiUriAccidentes}/getAccidentesList`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      rutEmpresa,
      idCentro,
    }),
  });


export const createEditAccidenteDataAPI = (idsiniestro, idcentro, idempresa, ruttrabajador = null, nombreTrabajador = null, fpresentacion = null, fsiniestro = null, medioTransporte=null, tipoAccidente=null) =>
  fetch(`${movConfig.apiUriAccidentes}/createEditAccidenteData`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      idsiniestro,
      idcentro,
      idempresa,
      ruttrabajador,
      nombreTrabajador,
      fpresentacion,
      fsiniestro,
      medioTransporte,
      tipoAccidente,
    }),
  });

export const getEmplyeesByCompanyRutAPI = (companyRut, size) => 
  fetch(`${apiConfig.apiUri}api/company/get/employees/${companyRut}?page=1&size=${size}&filter=`, {
    method: "GET",
    headers: defaultHeaders()
  });
  
export const getCountEmployeesByRutAPI = (companyRut) => 
  fetch(`${apiConfig.apiUri}api/company/get/employees/${companyRut}`, {
    method: "GET",
    headers: defaultHeaders()
  });


export const postFormQuestionaryAPI = (IDPlanMovilidad, responses) =>
  fetch(`${movConfig.apiUriEncuesta}/InsertEncuesta`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify({
      IDPlanMovilidad,
      tipoEncuesta: 2,
      responses,
    }),
  });
